import React, { createContext, useReducer } from "react";
import { backendGetRequest } from "../callBackend";

const initialState = {
    loading: true,
    loadingSubPortfolios: true,
    loadingUnlinkedProperties: true,
    dashboarddata: {},
    subPortfolios: [],
    unlinkedProperties: [],
    inFlight: false,
};

const deletePurposeFromProperty = (property, bankAccountPurpose) => {
    const newProperty = { ...property };
    delete newProperty.balances[bankAccountPurpose.id];
    return newProperty;
}

const deletePurposeFromSubPortfolio = (subPortfolio, bankAccountPurpose) => {
    const newSubPortfolio = { ...subPortfolio };
    delete newSubPortfolio.balances[bankAccountPurpose.id];
    return newSubPortfolio;
}
 

const mapSubPortfolios = (subPortfolios, bankAccountPurpose, operation) => {
    return subPortfolios.map((subPortfolio) => {
        return {
            ...subPortfolio,
            balances: {
                ...subPortfolio.balances,
                [bankAccountPurpose.id]: operation(subPortfolio.balances?.[bankAccountPurpose.id])
            }
        }
    });
}

const mapUnlinkedProperties = (unlinkedProperties, bankAccountPurpose, operation) => {
    return unlinkedProperties.map((property) => {
        return {
            ...property,
            balances: {
                ...property.balances,
                [bankAccountPurpose.id]: operation(property.balances[bankAccountPurpose.id])
            }
        }
    });
}  

const portfolioReducer = (state = initialState, action) => {
    switch (action.type) {
        case "RESET_PORTFOLIOS":
            const resetPortfolioData = { ...state };
            resetPortfolioData.loadingSubPortfolios = action.payload?.total_records > 0;
            resetPortfolioData.subPortfolios = [];

            return resetPortfolioData;

        case "RESET_PROPERTIES":
            const resetPropertyData = { ...state };
            resetPropertyData.loadingUnlinkedProperties = action.payload?.total_records > 0;
            resetPropertyData.unlinkedProperties = [];

            return resetPropertyData;

        case "FETCH_DASHBOARD_DATA":
            const newState1 = { ...state };

            newState1.loading = false;
            newState1.dashboarddata = action.payload.dashboardData;

            return newState1;
        
            case "FETCH_PORTFOLIOS":
                const newState2 = { ...state };
            
                newState2.loadingSubPortfolios = false;
                const fetchPortfolios = action.payload?.data?.portfolios || [];
            
                if (action.payload?.quickGet || false) {
                    const existingIds = newState2.subPortfolios.map(portfolio => portfolio.id);
                    const newPortfolios = fetchPortfolios.filter(portfolio => !existingIds.includes(portfolio.id));
                    newState2.subPortfolios = [...state.subPortfolios, ...newPortfolios];
                } else {
                    fetchPortfolios.forEach(portfolio => {
                        const index = newState2.subPortfolios.findIndex(p => p.id === portfolio.id);
                        if (index >= 0) {
                            newState2.subPortfolios[index] = portfolio;
                        } else {
                            newState2.subPortfolios.push(portfolio);
                        }
                    });
                }
                return newState2;
        
                case "FETCH_PROPERTIES":
                    const newState3 = { ...state };
                
                    newState3.loadingUnlinkedProperties = false;
                    const fetchProperties = action.payload?.data?.properties || [];
                
                    if (action.payload?.quickGet || false) {
                        const existingIds = newState3.unlinkedProperties.map(property => property.id);
                        const newProperties = fetchProperties.filter(property => !existingIds.includes(property.id));
                        newState3.unlinkedProperties = [...state.unlinkedProperties, ...newProperties];
                    } else {
                        fetchProperties.forEach(property => {
                            const index = newState3.unlinkedProperties.findIndex(p => p.id === property.id);
                            if (index >= 0) {
                                newState3.unlinkedProperties[index] = property;
                            } else {
                                newState3.unlinkedProperties.push(property);
                            }
                        });
                    }
                
                    return newState3;

        case "REQUEST_START":
            return { ...state, inFlight: true };

        case "REQUEST_END":
            return { ...state, inFlight: false };

        case "CREATE_PORTFOLIO":
            const { new_portfolios } = action.payload;

            const newPortfolios = new_portfolios.map((portfolio) => {
                return {
                    id: portfolio.id,
                    name: portfolio.name,
                    no_properties: 0,
                    balances: portfolio.info.balances,
                };
            });

            const newState = { ...state, inFlight: false };
            newState.subPortfolios = [...newState.subPortfolios, ...newPortfolios];

            return newState;

        case "DELETE_PORTFOLIO":
            const { portfolioId } = action.payload;

            const new_state = { ...state, inFlight: false };
            new_state.subPortfolios =
                new_state.subPortfolios.filter(
                    (portfolio) => portfolio.id !== portfolioId
                );

            return new_state;

        case "UPDATE_PORTFOLIO":
            const { portfolio_id, newPortfolioName } = action.payload;

            var updatedState = { ...state, inFlight: false };
            updatedState.subPortfolios =
                updatedState.subPortfolios.map(
                    (portfolio) => {
                        if (portfolio.id === portfolio_id) {
                            return {
                                ...portfolio,
                                name: newPortfolioName,
                            };
                        } else {
                            return portfolio;
                        }
                    }
                );
            return updatedState;

        case "CREATE_PROPERTY":
            const updated_state = { ...state, inFlight: false };
            updated_state.unlinkedProperties = [...updated_state.unlinkedProperties, ...action.payload.new_properties];
            return updated_state;

        case "ADD_PROPERTIES":
            const properties = action.payload;
            const updated_state2 = { ...state, inFlight: false };
            updated_state2.unlinkedProperties.push(...properties);
            return updated_state2;

        case "DELETE_PROPERTY":
            const { propertyId } = action.payload;

            const s = { ...state, inFlight: false };
            s.unlinkedProperties =
                s.unlinkedProperties.filter(
                    (property) => property.id !== propertyId
                );

            return s;

        case "UPDATE_PROPERTY":
            const { property_id, updated_property } = action.payload;
        
            const state_new = { ...state, inFlight: false };
            state_new.unlinkedProperties =
                state_new.unlinkedProperties.map(
                    (property) => {
                        if (property.id === property_id) {
                            if (updated_property.name === '') {
                                updated_property.name = updated_property.address.street_line_1 + ', ' + updated_property.address.city + ', ' + updated_property.address.state;
                            }
                            return {
                                ...property,
                                ...updated_property,
                            };
                        } else {
                            return property;
                        }
                    }
                );

            return state_new;

        case "ASSIGN_PROPERTY_TO_PORTFOLIO":
            const { propertyid, portfolioid } = action.payload;

            const modifiedState = { ...state, inFlight: false };

            modifiedState.subPortfolios =
                modifiedState.subPortfolios.map(
                    (portfolio) => {
                        if (portfolio.id === portfolioid) {
                            return {
                                ...portfolio,
                                no_properties: portfolio.no_properties + 1,
                            };
                        } else {
                            return portfolio;
                        }
                    }
                );

            modifiedState.unlinkedProperties =
                modifiedState.unlinkedProperties.filter(
                    (property) => property.id !== propertyid
                );

            return modifiedState;

        case "ADD_BANK_ACCOUNT_PURPOSE":
            var newBankAccountPurpose = action.payload.bankAccountPurpose;
            var updatedState = { ...state };
            updatedState.subPortfolios = mapSubPortfolios(updatedState.subPortfolios, newBankAccountPurpose, (balance) => 0);
            updatedState.unlinkedProperties = mapUnlinkedProperties(updatedState.unlinkedProperties, newBankAccountPurpose, (balance) => 0);
            return updatedState;
              
        case "DELETE_BANK_ACCOUNT_PURPOSE":
            var deletedBankAccountPurpose = action.payload.bankAccountPurpose;
            var updatedState = { ...state };
            updatedState.subPortfolios = updatedState.subPortfolios.map((subPortfolio) => deletePurposeFromSubPortfolio(subPortfolio, deletedBankAccountPurpose));
            updatedState.unlinkedProperties = updatedState.unlinkedProperties.map((property) => deletePurposeFromProperty(property, deletedBankAccountPurpose));
            return updatedState;
              
        case "EDIT_BANK_ACCOUNT_PURPOSE":
            var editedBankAccountPurpose = action.payload.bankAccountPurpose;
            var updatedState = { ...state };
            updatedState.subPortfolios = mapSubPortfolios(updatedState.subPortfolios, editedBankAccountPurpose, (balance) => balance);
            updatedState.unlinkedProperties = mapUnlinkedProperties(updatedState.unlinkedProperties, editedBankAccountPurpose, (balance) => balance);
            return updatedState;
                          
        default:
            return state;
    }
};

const useThunkReducer = (reducer, initialState) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const enhancedDispatch = React.useCallback(
        (action) => {
            if (typeof action === "function") {
                action(dispatch);
            } else {
                dispatch(action);
            }
        },
        [dispatch]
    );

    return [state, enhancedDispatch];
};

export const PortfolioContext = createContext();

export const PortfolioProvider = ({ children }) => {
    const [state, dispatch] = useThunkReducer(portfolioReducer, initialState);

    return (
        <PortfolioContext.Provider value={{ state, dispatch }}>
            {children}
        </PortfolioContext.Provider>
    );
};